import { SFC } from 'react';
import { connect, useSelector } from 'react-redux';
import { GlobalState } from 'ha/types/store';
import { getMediaQueryBreakpoints } from 'ha/modules/UI/selectors';

export interface MediaQueryBreakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

interface Props {
  mediaQueryBreakpoints: MediaQueryBreakpoints;
  children: (
    mediaQueryBreakpoints: MediaQueryBreakpoints,
  ) => JSX.Element | null;
}

const MediaQuery: SFC<Props> = ({ children, mediaQueryBreakpoints }) =>
  children(mediaQueryBreakpoints);

export default connect((state: GlobalState) => ({
  mediaQueryBreakpoints: getMediaQueryBreakpoints(state),
}))(MediaQuery);

export function useMediaQuery() {
  const mediaQueryBreakpoints: MediaQueryBreakpoints = useSelector(
    getMediaQueryBreakpoints,
  );

  return mediaQueryBreakpoints;
}
